import Tooltip from "@/components/tooltip";
import { useDebugMode } from "@/flokit/utils/debug/useDebugMode";
import { cx } from "class-variance-authority";
import { AiFillBug } from "react-icons/ai";

export function DebugModeContainer() {
  const [isDebugModeEnabled, setDebugModeEnabled] = useDebugMode();

  if (
    process?.env?.NEXT_PUBLIC_DEBUG !== "1" ||
    process?.env?.NODE_ENV === "production"
  ) {
    return null;
  }

  return (
    <div className="absolute z-50 select-none p-1">
      <DebugModeToggle
        isDebugModeEnabled={isDebugModeEnabled}
        setDebugModeEnabled={setDebugModeEnabled}
      />
    </div>
  );
}

function DebugModeToggle(props: {
  isDebugModeEnabled: boolean;
  setDebugModeEnabled(isEnabled: boolean): void;
}) {
  return (
    <Tooltip content="Toggle debug mode">
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        className={cx(
          "cursor-pointer items-center rounded border border-outline-destructive p-1 shadow",
          props.isDebugModeEnabled && "bg-action-destructive",
          !props.isDebugModeEnabled && "bg-action-destructive-disabled",
        )}
        onClick={() => props.setDebugModeEnabled(!props.isDebugModeEnabled)}
      >
        <AiFillBug
          size={16}
          color={props.isDebugModeEnabled ? "white" : "#cc0000"}
        />
      </div>
    </Tooltip>
  );
}
